const FeedbackListing = ({
  aliasEncoded = '',
  title = '',
  pricing = '',
  beds = '',
  photoUrl = '',
  inquiryId = '',
  submittedFeedbackCode = 0,
  uri = '',
  controlHash = '',
} = {}) => {
  return {
    aliasEncoded: String(aliasEncoded),
    uri: String(uri),
    title: String(title),
    pricing: String(pricing),
    beds: String(beds),
    photoUrl: String(photoUrl),
    inquiryId: String(inquiryId),
    submittedFeedbackCode: parseInt(submittedFeedbackCode),
    hash: String(controlHash),
  };
};

export default FeedbackListing;
